import React, { useEffect, useRef } from "react";
import jsQR from "jsqr";

export const QRReader = ({ onScan, setQrValue }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const streamRef = useRef(null);
    const scanIntervalRef = useRef(null);
    const restartIntervalRef = useRef(null);

    useEffect(() => {
        let cancelled = false;

        const startCamera = async () => {
            stopCamera();

            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: "user",
                        width: { ideal: 1280 },
                        height: { ideal: 720 }
                    },
                    audio: false
                });

                if (!cancelled) startVideo(stream);
            } catch (err) {
                console.error("Error cámara frontal", err);
            }
        };

        const startVideo = (stream) => {
            const video = videoRef.current;
            streamRef.current = stream;

            video.srcObject = stream;
            video.muted = true;
            video.playsInline = true;

            video.onloadedmetadata = () => {
                video.play();
                startScanning();
            };
        };

        const startScanning = () => {
            const video = videoRef.current;
            const canvas = canvasRef.current;
            const ctx = canvas.getContext("2d");

            canvas.width = video.videoWidth || 640;
            canvas.height = video.videoHeight || 480;

            scanIntervalRef.current = setInterval(() => {
                if (video.readyState < video.HAVE_CURRENT_DATA) return;

                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                const imageData = ctx.getImageData(
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );

                const qr = jsQR(
                    imageData.data,
                    imageData.width,
                    imageData.height
                );

                if (qr) {
                    stopCamera(); // 👈 paramos todo
                    setQrValue(qr.data);
                    onScan(qr.data);
                }
            }, 250);
        };

        const stopCamera = () => {
            clearInterval(scanIntervalRef.current);

            if (streamRef.current) {
                streamRef.current.getTracks().forEach(t => t.stop());
                streamRef.current = null;
            }
        };

        // ▶️ inicio normal
        startCamera();

        // 🔁 WATCHDOG: reinicio cada minuto
        restartIntervalRef.current = setInterval(() => {
            console.warn("🔄 Reinicio preventivo de cámara");
            startCamera();
        }, 60_000); // 1 minuto

        return () => {
            cancelled = true;
            clearInterval(scanIntervalRef.current);
            clearInterval(restartIntervalRef.current);
            stopCamera();
        };
    }, [onScan, setQrValue]);

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <video
                ref={videoRef}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transform: "scaleX(-1)"
                }}
                muted
                playsInline
            />
            <canvas ref={canvasRef} style={{ display: "none" }} />
        </div>
    );
};
